// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StorylineOpinary_wrapper__xo83L"};